var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"size":_vm.size,"isLoading":_vm.isLoading},on:{"click":_vm.redirectToDocumentToSign}},[_vm._v("\n  "+_vm._s(_vm.$t('buttonText'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }